// extracted by mini-css-extract-plugin
module.exports = {"ya-logo":"Header_ya-logo__28FUJ","header":"Header_header__1biYS"};